import { render } from "./FifthCut.vue?vue&type=template&id=36d06922&scoped=true"
import script from "./FifthCut.vue?vue&type=script&lang=js"
export * from "./FifthCut.vue?vue&type=script&lang=js"

import "./FifthCut.vue?vue&type=style&index=0&id=36d06922&lang=sass&scoped=true"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d06922"]])

export default __exports__